export default {"src":"/_next/static/media/icon-close-dialog.536c66e5.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};